// Load Profile Data Line Chart

import React from "react";
import ReactECharts from "echarts-for-react";

const LoadProfileDataLineChart: React.FC = () => {
  const data = [
    { time: "00:00-00:30", consumption: 120 },
    { time: "00:30-01:00", consumption: 150 },
  ];

  const times = data.map((item) => item.time);
  const consumptions = data.map((item) => item.consumption);

  const options = {
    xAxis: {
      type: "category",
      data: times,
      axisLabel: {
        color: "#5F6368",
        fontSize: 10,
        fontWeight: 400,
        lineHeight: 11,
        letterSpacing: 0.2,
      },
    },
    yAxis: [
      {
        type: "value",
        name: "Consumption/Demand",
        position: "left",
        axisLabel: {
          formatter: "{value}",
          color: "#5F6368",
          fontSize: 10,
          fontWeight: 400,
        },
        splitLine: {
          lineStyle: {
            color: "#E0E0E0",
            type: "dashed",
          },
        },
      },

      {
        type: "value",
        name: "Power Factor",
        min: 0,
        max: 1,
        interval: 0.1,
      },
    ],
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 1,
      borderColor: "#181B25",
      axisPointer: { type: "line" },
      formatter: (params: any) => {
        const [consumption] = params;
        return `
          <div style="padding: 5px 10px; border-radius: 3px; color: #ffffff;">
            <b>${consumption.axisValue}</b><br/>
            Consumption: ${consumption.data}
          </div>
        `;
      },
    },
    legend: {
      data: ["Consumption/Demand"],
      textStyle: {
        fontSize: 10,
        color: "#4C5269",
      },
    },
    series: [
      {
        name: "Consumption/Demand",
        data: consumptions,
        type: "line",
        yAxisIndex: 0,
        itemStyle: {
          color: "#1976d2",
        },
        lineStyle: {
          width: 2,
        },
      },
    ],
    grid: {
      left: "4%",
      right: "4%",
      bottom: "20%",
      containLabel: true,
    },
  };

  return <ReactECharts option={options} style={{ height: "350px" }} />;
};

export default LoadProfileDataLineChart;
